/**
 * @file index
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { TriggerGroup } from './TriggerGroup';
import { Popper as InnerPopper } from './Popper';
import { withPopperContent } from './withPopperContent';
import { withClickTrigger } from './withClickTrigger';
import { withFocusTrigger } from './withFocusTrigger';
import { withHoverTrigger } from './withHoverTrigger';
import { withContextMenuTrigger } from './withContextMenuTrigger';
import { withManualTrigger } from './withManualTrigger';
export var Popper = Object.assign(InnerPopper, {
  TriggerGroup: TriggerGroup,
  withPopperContent: withPopperContent,
  withClickTrigger: withClickTrigger,
  withFocusTrigger: withFocusTrigger,
  withHoverTrigger: withHoverTrigger,
  withContextMenuTrigger: withContextMenuTrigger,
  withManualTrigger: withManualTrigger
});